import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { Search } from "lucide-react";
import * as React from "react";

export interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	wrapperClassName?: string;
}

/**
 * Унифицированный поиск: иконка слева, белый фон, rounded-md (8px).
 * Используется в таблицах (rates, reconciliation result, activity-log).
 */
export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
	({ className, wrapperClassName, ...props }, ref) => {
		return (
			<div className={cn("relative", wrapperClassName)}>
				<Search
					aria-hidden
					className="pointer-events-none absolute top-1/2 left-2.5 h-4 w-4 -translate-y-1/2 text-slate-400"
				/>
				<Input ref={ref} type="search" className={cn("pl-8", className)} {...props} />
			</div>
		);
	},
);
SearchInput.displayName = "SearchInput";
